module.exports = __webpack_public_path__ + "img/shop1de.10d3b7a9.png";